















import Vue from 'vue';
import { ScheduleRuleType } from '../../../models/ScheduleRule';

export default Vue.extend({
  props: {
    type: Number,
    selected: Boolean,
    fixed: Boolean,
  },
  data() {
    return {
      ScheduleRuleType,
    };
  },
  computed: {
    iconName() {
      if (this.type === ScheduleRuleType.Event) {
        return 'event';
      } else if (this.type === ScheduleRuleType.Periodic) {
        return 'target';
      } else {
        return 'calendar';
      }
    },
  },
});
